import ReportsModalContainer from 'modules/reports/components/Modal/Container'
import {DocksContextProvider} from 'modules/reports/contexts/docks'
import {ModalsContextProvider} from 'modules/reports/contexts/modals'
import 'modules/reports/models/relationships'
import React from 'react'
import Routes from './Routes'

function Reports() {
  return (
    <ModalsContextProvider>
      <DocksContextProvider>
        <Routes />
        <ReportsModalContainer />
      </DocksContextProvider>
    </ModalsContextProvider>
  )
}

export default Reports
